<template>
  <el-dialog
    :visible="visible"
    width="80%"
    append-to-body
    :close-on-click-modal="false"
    class="page-dialog center-dialog-no-footer"
    @update:visible="val => emitUpdateVisible(val)"
  >
    <template #title>
      <MemberUidHeader :username="targetInfo.username" :uid="uid" :vip-level="targetInfo.vip_level">
        <span class="dialog-subtitle">提现记录</span>
      </MemberUidHeader>
    </template>
    <ManageWithdrawInfoTabV2 v-if="active" :target-info="targetInfo" :is-active="active" :reset-key="resetKey" />
  </el-dialog>
</template>

<script>
import { computed, ref, watch } from 'vue'
import ManageWithdrawInfoTabV2 from './tabs/ManageWithdrawInfoTabV2.vue'
import MemberUidHeader from './MemberUidHeader.vue'

export default {
  name: 'PayoutHistoryDialogV2',
  components: { ManageWithdrawInfoTabV2, MemberUidHeader },
  props: {
    visible: { type: Boolean, default: false },
    uid: { type: Number, default: 0 },
    targetInfo: { type: Object, default: () => ({}) },
  },
  setup(props, { emit }) {
    const resetKey = ref(0)
    const emitUpdateVisible = val => emit('update:visible', val)
    const active = computed(() => props.visible)

    watch(
      () => props.visible,
      v => {
        if (v) resetKey.value += 1
      }
    )

    return { resetKey, emitUpdateVisible, active }
  },
}
</script>

<style lang="scss" scoped>
.dialog-subtitle {
  color: #606266;
  font-weight: 500;
}
</style>
